import React from 'react';
import { motion } from 'framer-motion';

/**
 * Scroll reveal helper that fades content in from a direction once per viewport entry.
 */
const Reveal = ({
  children,
  direction = 'up',
  delay = 0,
  distance = 32,
  className = '',
  as: Component = motion.div,
  ...rest
}) => {
  const variants = {
    up: { hidden: { opacity: 0, y: distance }, visible: { opacity: 1, y: 0 } },
    down: { hidden: { opacity: 0, y: -distance }, visible: { opacity: 1, y: 0 } },
    left: { hidden: { opacity: 0, x: distance }, visible: { opacity: 1, x: 0 } },
    right: { hidden: { opacity: 0, x: -distance }, visible: { opacity: 1, x: 0 } },
  };

  const chosen = variants[direction] || variants.up;

  return (
    <Component
      className={className}
      initial="hidden"
      whileInView="visible"
      variants={chosen}
      transition={{ duration: 0.6, ease: 'easeOut', delay }}
      viewport={{ once: true, amount: 0.2 }}
      {...rest}
    >
      {children}
    </Component>
  );
};

export default Reveal;
